module.exports = __webpack_public_path__ + "static/media/img-117.5bddc304.jpg";